import axios from "axios";

const state = {
  selectedRace: null,
  availableRaces: null,
};

const mutations = {
  setSelectedRace(state, race) {
    state.selectedRace = race;
  },
  setAvailableRaces(state, races) {
    state.availableRaces = races;
  },
};

const actions = {
  exportResults({ rootState }, raceUUID) {
    let url = rootState.baseURL + rootState.apiRoutes.races + raceUUID + "/results/export/";
    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: "GET",
        responseType: "arraybuffer",
      })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  exportTrackers({ rootState }, raceUUID) {
    let url = rootState.baseURL + rootState.apiRoutes.races + raceUUID + "/trackers/export/";
    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: "GET",
        responseType: "arraybuffer",
      })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  exportWalletTransactions({ rootState, state }, walletUUID) {
    let url = rootState.baseURL + "finance/races/" + state.selectedRace.uuid + "/wallets/" + walletUUID + "/transactions/export/";
    return new Promise((resolve, reject) => {
      axios({
        url: url,
        method: "GET",
        responseType: "arraybuffer",
      })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default { namespaced: true, actions, state, mutations };
